'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _i18n = _interopRequireDefault(require("../../i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

_reactI18next.translate.setI18n(_i18n.default); // import fetch from


var Translate = function Translate(WrappedComponent) {
  var TranslatedComponent = /*#__PURE__*/function (_React$Component) {
    _inherits(TranslatedComponent, _React$Component);

    _createClass(TranslatedComponent, null, [{
      key: "component",
      get: function get() {
        return WrappedComponent;
      }
    }]);

    function TranslatedComponent(props) {
      _classCallCheck(this, TranslatedComponent);

      return _possibleConstructorReturn(this, (TranslatedComponent.__proto__ || Object.getPrototypeOf(TranslatedComponent)).call(this, props));
    }

    _createClass(TranslatedComponent, [{
      key: "render",
      value: function render() {
        if (!this.props.i18n.isInitialized) {
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
            className: "loader loader--medium"
          }));
        }

        return /*#__PURE__*/_react.default.createElement(WrappedComponent, this.props);
      }
    }]);

    return TranslatedComponent;
  }(_react.default.Component);

  TranslatedComponent.propTypes = {
    i18n: _propTypes.default.shape({
      isInitialized: _propTypes.default.bool
    })
  };
  return (0, _reactI18next.translate)([])(TranslatedComponent);
};

var _default = Translate;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/translate/index.js
// module id = 3
// module chunks = 0